import Vue from 'vue'
let eventBus = new Vue()

export let loginBus = {
  emit: function () {
    eventBus.$emit('openLogin', true)
  },
  on: function (callback) {
    eventBus.$on('openLogin', (data) => { callback(data) })
  }
}
export default eventBus
